import router from '@/router'
import axios from 'axios'
const globalAllert = new Event('callAllert')
// 對中臺API Server
// 當建立訂單或查詢訂單資料等 會員相關API， ticketId == ''  或 token expired 都視為未登入，回傳 2010
// 當需要具有身分時傳入guest token則回傳 2015

/**
 * @param {object} res The api result object.
 * @return {object} value.
 */
function verifyApiResultCodeNoTitleChanged(res) {
  if (typeof window.host_renewTokenInfo != 'undefined') {
    window.host_renewTokenInfo()
  } else if (res.data.code == 2015 && typeof window.host_login != 'undefined') {
    window.host_login(location.href)
  } else {
    return res
  }
}

/**
 *  更新token
 * @param {String} reason renew的原因
 */
async function renewTokenInfo(reason) {
  localStorage.removeItem('tokenInfo')
  localStorage.setItem('APP_INIT', 1)
  globalAllert.messageContent = reason
  globalAllert.callback = () => {
    if (localStorage.getItem('source') === 'e7g') {
      window.location = process.env.VUE_APP_E7G_HOME
    } else {
      router.replace({ name: 'home' })
    }
  }

  window.dispatchEvent(globalAllert)
}

/**
 *  更新title
 * @param {string} title
 */
function renewTitle(title) {
  document.title = title
  if (typeof window.host_title != 'undefined') window.host_title(title)
}

const api17 = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // process.env.VUE_APP_API_BASE_URL
  headers: {
    'Channel-Token': process.env.VUE_APP_CHANNEL_ID,
    FRONTEND: process.env.VUE_APP_DOMAIN,
  }
})
// 測試api
api17.defaults.headers.common['Authorization'] = ''
api17.defaults.headers['FRONTEND'] = process.env.VUE_APP_DOMAIN
api17.defaults.headers['Channel-Token'] = process.env.VUE_APP_CHANNEL_ID
api17.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
api17.defaults.withCredentials = true
api17.defaults.timeout = 60000
api17.interceptors.request.use(function(config) {
  config.headers['TSEC-TOKENINFO'] = localStorage.getItem('tokenInfo')
  config.headers['Channel-Token'] = process.env.VUE_APP_CHANNEL_ID
  config.headers['FRONTEND'] = process.env.VUE_APP_DOMAIN
  return config
})

api17.interceptors.response.use(
  response => {
    if (response.config.url === 'LoginCheck') {
      return Promise.resolve(response.data)
    }
    switch (response.data.code) {
      case 1000:
        // if (response.data && response.data.title) {
        //   renewTitle(response.data.title)
        // }
        return response.data
      case 2012:
        renewTokenInfo('登入逾時，請重新登入')
        break
      case 2015:
        renewTokenInfo('未登入，請先登入')
        break
      default:
      // throw response.data
    }
    return Promise.reject(response.data)
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 401: // Unauthorized 重取token
          router.replace('/error?errorCode=Token Unauthoritzed')
          renewTokenInfo('登入失效，請重新登入')
          break
        case 404:
          router.replace('/error?errorCode=找不到該頁面')
          console.log('找不到該頁面')
          break
        case 500:
          router.replace('/error?errorCode=500')
          break
        case 503:
          router.replace('/error?errorCode=服務失效')
          console.log('服務失效')
          break
        default:
          router.replace('/error?errorCode=連接錯誤')
          console.log(`連接錯誤${err.response.status}`)
      }
    } else {
      if (err.message.includes('timeout')) {
        console.log('time out')
        router.replace('/error?errorCode=Time_Out')
      } else if (err.message) {
        router.replace('/error?errorCode=' + err.message)
      } else if (err.code) {
        // router.replace('/error?errorCode=' + err.code)
      } else {
        router.replace('/error?errorCode=未定義錯誤')
      }
    }
    return Promise.reject(err.response)
  }
)

window.api = {}

api.authCheck = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('AuthCheck', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getSystemInfo = function() {
  return api17.get('https://www.17life.com/api/system/info')
}

api.getInitialConfig = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getInitialConfig')
      .then(function(res) {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

api.getHomepage = function(preview) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getHomePageData', {
        preview: preview,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getAllDealsForHomePage = function(startIndex) {
  return new Promise(function(resolve, reject) {
    api17
      .post('GetAllDealsForHomePage', {
        startIndex: startIndex,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

api.getSelectedDealsForHomePage = function(startIndex) {
  return new Promise(function(resolve, reject) {
    api17
      .post('GetSelectedDealsForHomePage', {
        startIndex: startIndex,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

api.getWeeklyHotProducts = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getWeeklyHotDeals', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getDealsByCategory = function(
  channelId,
  classId,
  areaId,
  sortType,
  startIndex
) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getDealsByCategory', {
        categoryId: channelId,
        classId: classId,
        areaId: areaId,
        sortType: sortType,
        startIndex: startIndex,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

api.getDealsByCoffee = function(
  channelId,
  classId,
  areaId,
  sortType,
  startIndex
) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getDealsByCoffee', {
        categoryId: channelId,
        classId: classId,
        areaId: areaId,
        sortType: sortType,
        startIndex: startIndex,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 29 建立客服案件（一般問題）
api.createIssue = function(categoryId, content, image, serviceNo) {
  return new Promise(function(resolve, reject) {
    api17
      .post('CreateIssue', {
        categoryId: categoryId,
        content: content,
        image: image,
        serviceNo: serviceNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 30 建立客服案件（訂單問題）
api.createOrderIssue = function(categoryId, content, image, orderNo) {
  return new Promise(function(resolve, reject) {
    api17
      .post('CreateOrderIssue', {
        categoryId: categoryId,
        content: content,
        image: image,
        orderNo: orderNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 31 取得案件分類
api.getCustomerServiceCategories = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('GetCustomerServiceCategories', {
        CategoryType: 0,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 32 取得案件列表
api.getCustomerServiceList = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('GetCustomerServiceList', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 33 取得案件對話
api.getConversations = function(serviceNo) {
  return new Promise(function(resolve, reject) {
    api17
      .post('GetConversations', {
        serviceNo: serviceNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 35 常見問題（問答）
api.getFaq = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getFaq', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 36 取得訂單列表(客服)
api.getCustomerServiceOrderList = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getCustomerServiceOrderList', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getProduct = function(bid, skipTitle) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getProduct', {
        bid,
      })
      .then(function(res) {
        if (skipTitle) {
          resolve(verifyApiResultCodeNoTitleChanged(res))
        } else {
          resolve(res)
        }
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getProductContent = function(bid) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getProductContent', {
        bid,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getRecommendProducts = function(bid) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getRecommendProducts', {
        bid,
        num: 5,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.checkProduct = function(bid) {
  return new Promise(function(resolve, reject) {
    api17
      .post('checkProduct', {
        bid,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getCityTownships = function() {
  return new Promise(function(resolve, reject) {
    const cacheJson = localStorage.getItem('cityTownShips')
    if (cacheJson != null) {
      const data = JSON.parse(cacheJson)
      resolve(data)
      return
    }
    api17
      .get('v2/system/addresses', {})
      .then(function(res) {
        if (res.code === 1000)
          localStorage.setItem('cityTownShips', JSON.stringify(res))
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 取得銀行
api.getBanks = function() {
  return new Promise(function(resolve, reject) {
    api17
      .get('v2/system/banks', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 取得分行
api.getBranchs = function(bankNo) {
  return new Promise(function(resolve, reject) {
    api17
      .get(`v2/system/bank/${bankNo}/branches`, {
        bankNo: bankNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

// 取得ATM退款時用的預填資料
api.getAtmRefundPrefillData = function(orderNo) {
  return new Promise(function(resolve, reject) {
    api17
      .post('GetAtmRefundPrefillData', {
        orderNo: orderNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getOrderListRedemption = function(checkIsCoffee) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getOrderListRedemption', { filterCoffee: checkIsCoffee })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.loginCheck = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('LoginCheck', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getOrderListDelivery = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getOrderListDelivery', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getCoffeeQty = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getCoffeeQty', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getCurationDeals = function(curationGuid, preview) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getCurationDeals', {
        curationGuid: curationGuid,
        preview: preview,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getOrderDetail = function(orderId, newOrderNo, orderNo) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getOrderDetail', {
        orderId: orderId,
        newOrderNo: newOrderNo,
        orderNumber: orderNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}
api.mailFrontCreditNote = function(orderId, returnName) {
  return new Promise(function(resolve, reject) {
    api17
      .post('mailFrontCreditNote', {
        orderId: orderId,
        returnName: returnName,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}
api.getCouponQrCode = function(orderId, newOrderNo) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getCouponQrCode', {
        orderId: orderId,
        newOrderNo: newOrderNo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.refund = function(
  orderNo,
  returnReason,
  returnReasonOption,
  atmRefundInfo,
  isReceive,
  receiverName,
  receiverAddress,
  receiverPhone
) {
  return new Promise(function(resolve, reject) {
    api17
      .post('refund', {
        orderNo: orderNo,
        returnReason: returnReason,
        returnReasonOption: returnReasonOption,
        isReceive: isReceive,
        receiverName: receiverName,
        receiverAddress: receiverAddress,
        receiverPhone: receiverPhone,
        atmRefundInfo: atmRefundInfo,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getChannelCategories = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getChannelCategories', {})
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.checkCoupon = function(CouponCode, Bid, TotalAmount) {
  return new Promise(function(resolve, reject) {
    api17
      .post('checkCoupon', {
        CouponCode: CouponCode,
        Bid: Bid,
        TotalAmount: TotalAmount,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.makeOrder = function(
  Bid,
  Quantity,
  StoreGuid,
  PaymentType,
  Amount,
  ShippingAmount,
  CouponCode,
  CardNumber,
  ExpireYear,
  ExpireMonth,
  SecurityCode,
  InstallmentPeriod,
  BuyerInfo,
  ItemOption,
  ShippingInfo,
  EinvoiceInfo,
  IsSaveEinvoice
) {
  return new Promise(function(resolve, reject) {
    api17
      .post('makeOrder', {
        Bid: Bid,
        Quantity: Quantity,
        StoreGuid: StoreGuid,
        PaymentType: PaymentType,
        Amount: Amount,
        ShippingAmount: ShippingAmount,
        CouponCode: CouponCode,
        CardNumber: CardNumber,
        ExpireYear: ExpireYear,
        ExpireMonth: ExpireMonth,
        SecurityCode: SecurityCode,
        InstallmentPeriod: InstallmentPeriod,
        BuyerInfo: BuyerInfo,
        EinvoiceInfo: EinvoiceInfo,
        ItemOption: ItemOption,
        ShippingInfo: ShippingInfo,
        IsSaveEinvoice: IsSaveEinvoice,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.validateAddress = function(addr, zipcode) {
  return new Promise(function(resolve, reject) {
    api17
      .post('ValidateAddress', {
        zipCode: zipcode,
        address: addr,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.checkOrder = function(transId) {
  return new Promise(function(resolve, reject) {
    api17
      .post('checkOrder', {
        transId: transId,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getUserProductSearchLogs = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getUserProductSearchLogs')
      .then(function(res) {
        return resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.deleteProductSearchLog = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('deleteProductSearchLog')
      .then(function(res) {
        return resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getHotSearchProduct = function() {
  return new Promise(function(resolve, reject) {
    api17
      .post('getHotSearchProduct')
      .then(function(res) {
        return resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.searchProduct = function(keyWord, categoryId, areaId) {
  return new Promise(function(resolve, reject) {
    api17
      .post('searchProduct', {
        keyWord: keyWord,
        categoryId: categoryId,
        areaId: areaId,
      })
      .then(function(res) {
        return resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.searchProductGetSort = function(data, sort, pageSize, startIndex) {
  return new Promise(function(resolve, reject) {
    api17
      .post('searchProductGetSort', {
        data: data,
        sort: sort,
        pageSize: pageSize,
        startIndex: startIndex,
      })
      .then(function(res) {
        return resolve(res)
      })
      .catch(function(err) {
        reject(err)
      })
  })
}

api.getPiAccessToken = async PI_GRANT_CODE => {
  const res = await api17.post('getPiAccessToken', {
    code: PI_GRANT_CODE,
  })
  return res
}

api.getPiRefreshToken = async PI_REFRESH_TOKEN => {
  const res = await api17.post('getPiRefreshToken', {
    refresh_token: PI_REFRESH_TOKEN,
  })
  return res
}

api.getPiMe = async PI_ACCESS_TOKEN => {
  const res = await api17.post('GetPiMe', {
    access_token: PI_ACCESS_TOKEN,
  })
  return res
}

api.getPiUserInfo = async (PI_ACCESS_TOKEN, PI_USER_ID) => {
  const res = await api17.post('GetPiUserInfo', {
    access_token: PI_ACCESS_TOKEN,
    user_id: PI_USER_ID,
  })
  return res
}

api.getPiUserPoint = async (PI_ACCESS_TOKEN, PI_USER_ID) => {
  const res = await api17.post('GetPiUserPoint', {
    access_token: PI_ACCESS_TOKEN,
    user_id: PI_USER_ID,
  })
  return res
}

api.setCollection = async (method, bid) => {
  const res = await api17.post('setCollection', {
    method: method,
    bid: bid,
  })
  return res
}

api.getCollectionList = async () => {
  const res = await api17.post('getCollectionList')
  return res
}

api.validateEinvoiceInfo = async (type, carrierId) => {
  const encodedCarrierId = encodeURIComponent(carrierId)
  const res = await api17.get(`v2/order/carrier/${type}/${encodedCarrierId}`)
  return res
}

api.getMaintenanceInfo = async () => {
  const res = await api17.get('v2/channel/maintenance/active')
  return res
}

api.getSelfBuildCategoryClass = async selfBuildCategoryId => {
  const res = await api17.post('getSelfBuildCategoryClass', {
    selfBuildCategoryId: selfBuildCategoryId,
  })
  return res
}

api.getSelfBuildCategoryProducts = function(
  selfBuildCategoryId,
  classId,
  sortType,
  startIndex
) {
  return new Promise(function(resolve, reject) {
    api17
      .post('getSelfBuildCategoryProducts', {
        selfBuildCategoryId: selfBuildCategoryId,
        classId: classId,
        sortType: sortType,
        startIndex: startIndex,
      })
      .then(function(res) {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

api.getCheckoutInfo = async () => {
  const res = await api17.get('member/checkout-info')
  return res
}
